"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHttpService = void 0;
const types_1 = require("../../types");
const forgot_password_1 = require("../../types/auth/forgot-password");
const logout_1 = require("../../types/auth/logout");
const sign_up_doctor_attending_1 = require("../../types/auth/sign-up-doctor-attending");
const sign_up_doctor_substitute_1 = require("../../types/auth/sign-up-doctor-substitute");
const http_service_1 = require("../http.service");
class AuthHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/auth`);
    }
    login(payload) {
        return this.postEntity('login', {
            body: payload,
            schema: types_1.loginApiResponseSchema,
        });
    }
    logout() {
        return this.post('logout', {
            body: {},
            schema: logout_1.logoutApiResponseSchema,
        });
    }
    forgotPassword(payload) {
        return this.post('forgot-password', {
            body: payload,
            schema: forgot_password_1.forgotPasswordApiResponseSchema,
        });
    }
    resetPassword(payload) {
        return this.post('reset-password', {
            body: payload,
            schema: types_1.resetPasswordApiResponseSchema,
        });
    }
    signUpDoctorSubstitute(payload) {
        return this.post('sign-up-doctor-substitute', {
            body: payload,
            schema: sign_up_doctor_substitute_1.signUpDoctorSubstituteApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    signUpDoctorAttending(payload) {
        return this.post('sign-up-doctor-attending', {
            body: payload,
            schema: sign_up_doctor_attending_1.signUpDoctorAttendingApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
exports.AuthHttpService = AuthHttpService;
